var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.dialog
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v("Change FTP password")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c(
              "v-form",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "pt-4",
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "mb-0"
                          },
                          [
                            _vm._v(" Change account "),
                            _c("strong", [_vm._v(_vm._s(_vm.account.user))]),
                            _vm._v(" password. ")
                          ]
                        )
                      ]
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c("compact-password", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|min:8",
                              expression: "'required|min:8'"
                            }
                          ],
                          attrs: {
                            outlined: "",
                            autocomplete: "new-password",
                            label: "Password",
                            "data-vv-name": "password",
                            "data-vv-as": "Password",
                            "error-messages": _vm.errors.collect("password"),
                            "with-generator": ""
                          },
                          model: {
                            value: _vm.password,
                            callback: function callback($$v) {
                              _vm.password = $$v
                            },
                            expression: "password"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  loading: _vm.loading
                },
                on: {
                  click: _vm.changePassword
                }
              },
              [_vm._v("Change Password")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }